import { render } from "./GridIndex.vue?vue&type=template&id=1d22d58a&scoped=true&ts=true"
import script from "./GridIndex.vue?vue&type=script&lang=ts"
export * from "./GridIndex.vue?vue&type=script&lang=ts"

import "./GridIndex.vue?vue&type=style&index=0&id=1d22d58a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d22d58a"]])

export default __exports__